import { createContext, useContext, useState, ReactNode } from "react";

type ToggleContextType = {
  isToggle: boolean;
  setIsToggle: (val: boolean) => void;
  navActive: boolean;
  setNavActive: (val: boolean) => void;
  toggleQuickLinkMenu: boolean;
  setToggleQuickLinkMenu: (val: boolean) => void;
  hideOverlay: () => void;
};

const ToggleContext = createContext<ToggleContextType | undefined>(undefined);

export const ToggleProvider = ({ children }: { children: ReactNode }) => {
  const [isToggle, setIsToggle] = useState(false);
  const [navActive, setNavActive] = useState(true);
  const [toggleQuickLinkMenu, setToggleQuickLinkMenu] = useState(false);


  const hideOverlay = () => {
    setIsToggle(false);
    setToggleQuickLinkMenu(false);
  };

  return (
    <ToggleContext.Provider
      value={{
        isToggle,
        setIsToggle,
        navActive,
        setNavActive,
        toggleQuickLinkMenu,
        setToggleQuickLinkMenu,
        hideOverlay,
      }}
    >
      {children}
    </ToggleContext.Provider>
  );
};

export const useToggleContext = () => {
  const context = useContext(ToggleContext);
  if (!context) {
    throw new Error("useToggleContext must be used within a ToggleProvider");
  }
  return context;
};
